// const API_BASE_URL = "http://localhost:3002"
const API_BASE_URL = "https://seagreen-quail-823805.hostingersite.com"
export default API_BASE_URL;